define([], function () {

    // модуль управления модальными окнами для того, чтобы они удалялись при переходе между разделами приложения по url
    var modalViews = {};

    // должно вызываться перед отрисовкой модального окна вебикс
    var registerModalView = function (view) {
        modalViews[view.config.id] = view;
    };

    var removeModalViews = function (viewId, isDestruct) {
        if (isDestruct) {
            if (viewId && $$(viewId)) {
                $$(viewId).destructor();
            } else {
                for (var vid in modalViews) {
                    if (!viewId || viewId === modalViews[vid].config.id)
                        modalViews[vid].destructor();
                }
            }
        }
        if (viewId)
            delete modalViews[viewId];
        else
            modalViews = {};
    };

    return {
        registerModalView: registerModalView,
        removeModalViews: removeModalViews
    };
});